var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"OperateLhc-8"},[_c('board-fast',{attrs:{"client":_vm.client,"group":[0],"step":true,"transmit":"six-tail","radio":true}}),_c('group',{attrs:{"client":_vm.client,"list":_vm.Table[0],"length":1,"radio":true,"transmit":false,"show-total":"end"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }